import { render } from "./ListClient.vue?vue&type=template&id=53c6c0ee&scoped=true"
import script from "./ListClient.vue?vue&type=script&lang=js"
export * from "./ListClient.vue?vue&type=script&lang=js"

import "./ListClient.vue?vue&type=style&index=0&id=53c6c0ee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c6c0ee"]])

export default __exports__